import {observer} from 'mobx-react-lite'
import React, {useEffect} from 'react'
import {Lang} from 'yougile-lang'
import {ffLazyLoading, hasFeatureFlag} from 'yougile-util'
import {Badge} from '@components/common/base/badge'
import {Chips} from '@components/common/base/chips'
import {
  PredefinedFilter,
  useSearchStore
} from '@components/right-panel/search/search-store'
import {useForceUpdate} from '@containers/hooks'
import {idTasksStore} from '@extensions/id-tasks/id-tasks-store'
import {CategorySelect} from './category-select'
import {ProjectSelect} from './project-select'

const usePredefinedFilters = () => {
  const [state] = useSearchStore()

  const res: {id: PredefinedFilter; title: string}[] = [
    {
      id: 'everywhere',
      title: Lang.msg.globalSearch.predefinedFilter.everywhere
    },
    {
      id: 'task-titles',
      title: Lang.msg.globalSearch.predefinedFilter.taskTitles
    },
    {
      id: 'chat-titles',
      title: Lang.msg.globalSearch.predefinedFilter.chatTitles
    },
    {
      id: 'messages',
      title: Lang.msg.globalSearch.predefinedFilter.messages
    },
    {
      id: 'current-project',
      title: Lang.msg.globalSearch.predefinedFilter.currentProject
    },
    {
      id: 'custom',
      title: Lang.msg.globalSearch.predefinedFilter.customFilter
    }
  ]
  return res.filter(x => state.availablePredefinedFilters.has(x.id))
}

const withLazyTasks = hasFeatureFlag(ffLazyLoading)

export const SearchFilter = observer(() => {
  const [state, store] = useSearchStore()
  const forceUpdate = useForceUpdate()
  useEffect(() => {
    forceUpdate()
  }, [idTasksStore.state.modified])

  const predefinedFilters = usePredefinedFilters()

  return (
    <div className="flex flex-col gap-8">
      <div className="flex gap-8">
        {predefinedFilters.map(x => {
          let count = state.resultsFiltered.get(x.id)?.length ?? 0
          if (withLazyTasks && x.id === 'everywhere') {
            count = state.totalCountRaw
          }
          return (
            <Chips
              key={x.id}
              onClick={() => store.onChangeFilterType(x.id)}
              active={state.filterState.type === x.id}
              className="flex-initial min-w-0"
            >
              <span className="truncate">{x.title}</span>
              {state.debouncedValue && (
                <Badge type="rounded" className="!bg-primary flex-none">
                  {count}
                </Badge>
              )}
            </Chips>
          )
        })}
      </div>
      {state.filterState.type === 'custom' && (
        <div className="flex gap-16 p-8">
          <ProjectSelect />
          <CategorySelect />
        </div>
      )}
    </div>
  )
})
